import EditableTextInputs from '../../../components/EditableTextInputs';
import RichTextEditor from '../../../pages/RichTextEditor';

export default function PageTextEditor({ editor }) {
  const {
    additionalEntries,
    layoutItems, onAddToLayout, onToggleLayoutBox, layoutBusy,
    bookId,
    onContentSave,
    onImageGenerated,
    onRemoveAdditionalEntry,
    onRenameAdditionalEntry,
    renamingText,
    onSaveAdditionalEntries,
    onUpdateAdditionalEntryText,
    pageId,
    pageLanguage,
    saveTextChanges,
    savingFields,
    setTextByLang,
    textByLang,
    translateText,
  } = editor;

  return (
    <>
      <div id="text-content-editor">
        <EditableTextInputs
          pageLanguage={pageLanguage}
          textByLang={textByLang}
          setTextByLang={setTextByLang}
          savingFields={savingFields}
          saveTextChanges={saveTextChanges}
          translateText={translateText}
          pageId={pageId}
          bookId={bookId}
          additionalEntries={additionalEntries}
          layoutItems={layoutItems}
          onAddToLayout={onAddToLayout}
          onToggleLayoutBox={onToggleLayoutBox}
          layoutBusy={layoutBusy}
          onUpdateAdditionalEntryText={onUpdateAdditionalEntryText}
          onSaveAdditionalEntries={onSaveAdditionalEntries}
          onRemoveAdditionalEntry={onRemoveAdditionalEntry}
          onRenameAdditionalEntry={onRenameAdditionalEntry}
          renamingText={renamingText}
        />
      </div>

      <details className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
        <summary className="cursor-pointer text-sm font-semibold text-slate-800">
          Advanced: create styled text as an image
        </summary>
        <p className="mt-2 text-xs text-slate-500">
          Use this only when a normal text box is not enough. The result becomes an image on the page.
        </p>
        <div className="mt-4">
          <RichTextEditor
            pageId={pageId}
            selectedLanguage={pageLanguage}
            onImageGenerated={onImageGenerated}
            onContentSave={onContentSave}
          />
        </div>
      </details>
    </>
  );
}
